<template>
  <div class="account-dorm">
    <MultiStepForm
      :step-titles="stepTitles"
      :step="step"
      :max-step="5"
      :loading="loading"
      @update:step="step = $event"
      @submit="save"
      class="user__list-offer"
    >
      <template #step-1>
        <div class="col-xl-12">
          <keep-alive>
            <v-select
              :options="dorms"
              placeholder="Yurt Seçiniz"
              v-model="dorm_id"
              :selected-value="dorm_id"
              style="font-weight: bold"
              @onselect="selectDorm"
            />
          </keep-alive>
        </div>
      </template>
      <template #step-2>
        <div class="col-xl-12">
          <v-input placeholder="Oda Adı" v-model="title" />
          <v-input
            placeholder="Oda Kapasitesi (Kişi)"
            type="number"
            v-model="capacity"
          />
          <v-input placeholder="Yatak Sayısı" type="number" v-model="number" />
          <v-input
            placeholder="Oda Büyüklüğü (m2)"
            type="number"
            v-model="size"
          />
          <Checkbox :value="is_active" @update="is_active = !is_active"
            >Oda Aktif (Herkes görebilir)</Checkbox
          >
        </div>
      </template>
      <template #step-3>
        <div class="col-xl-12">
          <RoomGallery
            :gallery="images"
            @update="images = $event"
            @delete="deleteImage"
          ></RoomGallery>
        </div>
      </template>
      <template #step-4>
        <div class="col-xl-12">
          <DormRoomFeatures
            :build-features="buildFeatures"
            :room-features="roomFeatures"
            :services="services"
            @update="updateRoomFeature"
          ></DormRoomFeatures>
        </div>
      </template>
      <template #step-5>
        <div class="col-xl-12">
          <v-input placeholder="Günlük Fiyat (TL)" v-model="daily_price" />
          <v-input placeholder="Aylık Fiyat (TL)" v-model="monthly_price" />
          <Checkbox
            :value="is_sale_active"
            @update="is_sale_active = !is_sale_active"
            >Satış Aktif</Checkbox
          >
        </div>
      </template>
    </MultiStepForm>
  </div>
</template>

<script>
import Checkbox from '@/components/Checkbox/Checkbox.vue'
import MultiStepForm from '@/components/Form/MultiStepForm.vue'
import RoomGallery from '@/components/Room/RoomGallery.vue'
import {
  buildFeatures,
  roomFeatures,
  services
} from '@/static/dorm-properties.js'
import { toFormData } from '@/utils/form-data.js'
import axios from 'axios'
import DormRoomFeatures from './DormRoomFeatures.vue'

export default {
  components: {
    MultiStepForm,
    Checkbox,
    DormRoomFeatures,
    RoomGallery
  },
  data() {
    return {
      step: 0,
      loading: false,
      stepTitles: [
        {
          title: 'Yurt Seçimi',
          subtitle: 'Yurt seçimi yaparak oda düzenlemeye başlayabilirsiniz.'
        },
        {
          title: 'Oda Bilgileri',
          subtitle:
            'Oda bilgilerini girerek oda düzenlemeye devam edebilirsiniz.'
        },
        {
          title: 'Oda Görselleri',
          subtitle:
            'Oda görsellerini yükleyerek oda düzenlemeye devam edebilirsiniz.'
        },
        {
          title: 'Oda Özellikleri',
          subtitle:
            'Oda özelliklerini girerek oda düzenlemeye devam edebilirsiniz.'
        },
        {
          title: 'Oda Fiyatları',
          subtitle:
            'Oda fiyat bilgilerini girerek oda düzenlemeyi tamamlayabilirsiniz.'
        }
      ],
      dorms: [],
      buildFeatures: [],
      images: [],
      roomFeatures: [],
      services: [],
      dorm_id: '0',
      title: '',
      number: 0,
      capacity: '0',
      size: '0',
      daily_price: 0,
      monthly_price: 0,
      is_sale_active: true,
      is_active: false
    }
  },
  methods: {
    uploadImage(image) {
      this.images.push(image)
    },
    async deleteImage(image) {
      if (image.file) return // new image
      await axios
        .post(`/dorm/room/image-destroy/${image.id}`)
        .catch(() => ({ data: {} }))
    },
    updateRoomFeature({ key, id }) {
      this[key].forEach(b => {
        if (b.id === id) b.value = !b.value
      })
    },
    selectDorm(opt) {
      this.dorm_id = String(opt.id)
    },
    async getRoomDetail() {
      const id = this.$route.params.id
      const res = await axios.get(`/dorm/rooms/${id}`).catch(() => ({
        data: { id: -1 }
      }))
      if (res.data.id === -1) return
      this.dorm_id = String(res.data.dorm_id)
      this.size = String(res.data.size)
      this.daily_price = res.data.daily_price
      this.monthly_price = res.data.monthly_price
      this.title = res.data.title
      this.capacity = String(res.data.capacity)
      this.number = res.data.number
      this.images = res.data.images.map(i => ({ ...i, url: i.filename }))
      this.is_active = res.data.is_active === 1
      this.is_sale_active = res.data.is_sale_active === 1
      res.data.room_properties.forEach(prop => {
        this.buildFeatures.forEach(b => {
          if (b.id === prop.id) b.value = true
        })
        this.roomFeatures.forEach(b => {
          if (b.id === prop.id) b.value = true
        })
        this.services.forEach(b => {
          if (b.id === prop.id) b.value = true
        })
      })
    },
    getFeatureList() {
      this.buildFeatures = buildFeatures.map(b => ({ ...b, value: false }))
      this.roomFeatures = roomFeatures.map(b => ({ ...b, value: false }))
      this.services = services.map(b => ({ ...b, value: false }))
    },
    async getDorms() {
      const res = await axios.get('/dorm/dorms').catch(() => ({ data: [] }))
      this.dorms = res.data.map(r => ({ ...r, id: String(r.id) }))
    },
    async save() {
      this.loading = true
      let data = {
        dorm_id: +this.dorm_id,
        title: this.title,
        capacity: +this.capacity,
        size: +this.size,
        number: this.number,
        daily_price: this.daily_price,
        monthly_price: this.monthly_price,
        is_sale_active: +this.is_sale_active,
        is_active: +this.is_active,
        props: [],
        images: []
      }
      this.buildFeatures
        .filter(b => b.value)
        .forEach(b => {
          data.props.push(String(b.id))
        })
      this.images.forEach(image => {
        if (image.file) data.images.push(image.file)
      })
      this.roomFeatures
        .filter(b => b.value)
        .forEach(b => {
          data.props.push(String(b.id))
        })
      this.services
        .filter(b => b.value)
        .forEach(b => {
          data.props.push(String(b.id))
        })
      const formData = toFormData(data)
      formData.append('_method', 'PUT')
      const res = await axios
        .post(`/dorm/rooms/${this.$route.params.id}`, formData)
        .catch(() => ({ data: {}, status: 400 }))
      this.loading = false
      if (![200, 201].includes(res.status)) {
        this.$toast.center('Bir hata oluştu.')
      } else {
        this.$toast.center('Oda başarıyla güncellendi.')
        this.$router.push('/yurt-yonetimi/yurtlar/odalar')
      }
    }
  },
  mounted() {
    this.getFeatureList()
    this.getDorms()
    this.getRoomDetail()
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/scss/components/dorm-room';
</style>
